import React, { useCallback } from "react";
import { usePlaidLink } from "react-plaid-link";
import { toast } from "react-toastify";
import { Constants } from "../libs/Constants";
import { create } from "../libs/dbFunctions";
function OpenPlaidLink({ token, onSuccess, onExit }) {
  const [loading, setLoading] = React.useState(false);
  const addAccount = async (token, metadata) => {
    setLoading(true);
    // Get token    
    let tokenResponse = await create(Constants.dbTypes.ACCOUNT, {
      token,
      account: metadata?.accounts?.[0],
    });
    if (tokenResponse) {
      if (onSuccess) {
        onSuccess(tokenResponse);
      }
    }
    setLoading(false);
  };
  const onPlaidSuccess = useCallback((public_token, metadata) => {
    if (public_token) {
      // call create account api
      addAccount(public_token, metadata);
    }
    // send public_token to server
  }, []);

  const onPlaidExit = useCallback((error) => {
    if (error != null) {
      toast.error(error.display_message);
    }
    onExit();
  }, []);
  const onPlaidEvent = useCallback((eventName, metadata) => {
    if (eventName !== 'EXIT' && eventName !== 'ERROR' && metadata) {
      toast.error(metadata.error_message);
    }
  }, []);
  const config = {
    // When re-initializing Link after OAuth redirection, the same
    // Link token from the first initialization must be used
    token: token.link_token,
    env: token.environment,
    onSuccess: onPlaidSuccess,
    // receivedRedirectUri: document.location.href, // required for OAuth
    onExit: onPlaidExit,
    onEvent: onPlaidEvent
    // onEvent
  };

  const { open, ready, error } = usePlaidLink(config);

  // this opens link as soon as it's ready
  React.useEffect(() => {
    if (!ready) {
      return;
    }
    open();
  }, [ready, open]);
  if (loading) {
    return "Loading..";
  }
  return null;
}

export default OpenPlaidLink;
